'use client';

import { FilterButton, SelectModal } from '@sympla/sympla-components';
import { AlgoliaFilterAttributes } from 'constants/algolia';
import React, { useState } from 'react';
import { useMenu } from 'react-instantsearch';

interface DropdownFilterProps {
  attribute: string
  attributeLabel: string;
}

const ACCESSIBLE_FOR_FREE_ITEMS = [
  { label: 'Grátis', value: 'true' },
  { label: 'Pago', value: 'false' },
];

const TYPE_ITEMS = [
  { label: 'Online', value: 'ONLINE' },
  { label: 'Presencial', value: 'NORMAL' },
  { label: 'Sympla Play', value: 'ONDEMAND' },
];

export function DropdownFilter(props: DropdownFilterProps) {
  const { attribute, attributeLabel } = props;
  const [open, setOpen] = useState(false);

  const { items, refine } = useMenu({ attribute });

  const refinedItem = items.find((item) => item.isRefined);
  const currentValue = refinedItem ? refinedItem.value : '';

  const handleChange = ({ value }: {value: string}) => {
    if (value === currentValue) {
      setOpen(false);
      return;
    }
    refine(value);
    setOpen(false);
  };

  const mountOptions = (attribute: string) => {
    switch (attribute) {
      case AlgoliaFilterAttributes.IS_ACCESSIBLE_FOR_FREE:
        return ACCESSIBLE_FOR_FREE_ITEMS;
      case AlgoliaFilterAttributes.TYPE:
        return TYPE_ITEMS;
      default:
        return items.map((item) => ({
          label: item.label,
          value: item.value,
        }));
    }
  };

  const mountColumns = (attribute: string) => {
    switch (attribute) {
      case AlgoliaFilterAttributes.IS_ACCESSIBLE_FOR_FREE:
      case AlgoliaFilterAttributes.TYPE:
        return {
          xs: 1,
          sm: 1,
          md: 1,
        };
      default:
        return {
          xs: 1,
          sm: 2,
          md: 3,
        };
    }
  };

  const mountSelectedItem = (attribute: string) => {
    switch (attribute) {
      case AlgoliaFilterAttributes.IS_ACCESSIBLE_FOR_FREE:
        return ACCESSIBLE_FOR_FREE_ITEMS.find(({ value }) => value === currentValue)?.label as string;
      case AlgoliaFilterAttributes.TYPE:
        return TYPE_ITEMS.find(({ value }) => value === currentValue)?.label as string;
      default:
        return refinedItem?.label || '';
    }
  };

  return (
    <>
      <FilterButton
        selectedItem={mountSelectedItem(attribute)}
        onClick={() => setOpen(true)}
        removeSelectedItem={() => {
          refine('');
        }}
        btnType="filter"
        upperCase={false}
      >
        {attributeLabel}
      </FilterButton>
      <SelectModal
        open={open}
        border
        title={attributeLabel}
        accessibilityTitle={attributeLabel}
        onSelect={handleChange}
        columns={mountColumns(attribute)}
        options={mountOptions(attribute)}
        hideModal={() => setOpen(false)}
        widthModal={600}
      />
    </>
  );
}
